import React from 'react';
import { BrowserRouter as Router, Switch, Route, Redirect } from 'react-router-dom';

import Map from 'containers/Map';
import Email from 'containers/Email';

import './App.scss';

function App() {
  return (
    <Router>
      <div className="App">
        <Switch>
          <Route path="/email/:id/:signature" exact component={Email} />
          <Route path="/map/:id?/:signature?" component={Map} />
          <Redirect from="/" to="/map" />
        </Switch>
      </div>
    </Router>
  );
}

export default App;
